// PHASE 2 — device-local photo state (no auth). Favorites and "which photos
// this device has liked" live only in localStorage, keyed per tournament.
// Favorites power a personal Favorites tab; the liked-set is the no-auth guard
// that lets a device contribute exactly +1 to the SHARED likeCount (toggle −1).
//
// The list logic is pure + unit-tested; localStorage I/O is a thin wrapper.

// Pure: toggle an id in a list, returning a NEW array (immutable).
export function toggleId(list, id) {
  const arr = Array.isArray(list) ? list : []
  return arr.includes(id) ? arr.filter((x) => x !== id) : [...arr, id]
}

export function hasId(list, id) {
  return Array.isArray(list) && list.includes(id)
}

const favKey = (t) => `photoFav_${t}`
const likedKey = (t) => `photoLiked_${t}`

function read(key) {
  try {
    const raw = localStorage.getItem(key)
    const v = raw ? JSON.parse(raw) : []
    return Array.isArray(v) ? v : []
  } catch { return [] }
}
function write(key, list) {
  try { localStorage.setItem(key, JSON.stringify(list)) } catch { /* private mode / full */ }
}

// Favorites (personal tab).
export function getFavorites(t) { return read(favKey(t)) }
export function isFavorite(t, id) { return hasId(read(favKey(t)), id) }
export function toggleFavorite(t, id) {
  const next = toggleId(read(favKey(t)), id)
  write(favKey(t), next)
  return next
}

// Liked-set (the per-device +1 guard for the shared likeCount).
export function getLiked(t) { return read(likedKey(t)) }
export function hasLiked(t, id) { return hasId(read(likedKey(t)), id) }
export function toggleLiked(t, id) {
  const next = toggleId(read(likedKey(t)), id)
  write(likedKey(t), next)
  return next
}
